import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const About = () => {
	return (
		<Container className="py-5">
			<Row className="mb-4 text-center">
				<Col>
					<h1 className="fw-bold">
						<span role="img" aria-label="sparkles">
							✨
						</span>{" "}
						About Get2Know{" "}
						<span role="img" aria-label="sparkles">
							✨
						</span>
					</h1>
					<p className="text-muted">A simple way to create events, connect with people, and break the ice!</p>
				</Col>
			</Row>

			<Row className="g-4">
				<Col md={4}>
					<Card className="shadow-sm h-100 text-center p-3">
						<Card.Body>
							<div className="mb-3" style={{ fontSize: "2rem" }}>
								<i className="bi bi-calendar-event"></i>
							</div>
							<Card.Title>Create Social Events</Card.Title>
							<Card.Text>
								Plan meetups, parties, or casual get-togethers in just a few clicks. <br />
								🗓️ Share details, time, and location so everyone is on the same page
							</Card.Text>
						</Card.Body>
					</Card>
				</Col>

				<Col md={4}>
					<Card className="shadow-sm h-100 text-center p-3">
						<Card.Body>
							<div className="mb-3" style={{ fontSize: "2rem" }}>
								<i className="bi bi-people"></i>
							</div>
							<Card.Title>Bring People Together</Card.Title>
							<Card.Text>
								Make introductions easier 🙌. Using our 'Icebreaker' functionality, we make initiating conversations fun
								and interesting, no more 'Where are you from?' or 'What do you do?'. <br /> You can already see that in
								their profile and start talking about their interests and hobbies right away
							</Card.Text>
						</Card.Body>
					</Card>
				</Col>

				<Col md={4}>
					<Card className="shadow-sm h-100 text-center p-3">
						<Card.Body>
							<div className="mb-3" style={{ fontSize: "2rem" }}>
								<i className="bi bi-stars"></i>
							</div>
							<Card.Title>AI-Powered Ice Breaker</Card.Title>
							<Card.Text>
								Our unique <strong>Ice Breaker</strong> feature 💬 sparks conversations with AI-generated questions
								tailored to your profile—hobbies, interests, nationality, and more. You decide what to share and how to
								connect!
							</Card.Text>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			<Row className="mt-5 text-center">
				<Col>
					<h3 className="mb-3">
						<i className="bi bi-heart-fill text-danger me-2"></i>
						Let’s make social events fun, welcoming, and meaningful!
					</h3>

					<h3 className="mt-4">
						Got questions?
						<Link to="/contact" className="ms-3 text-decoration-none">
							<Button variant="outline-danger" className="my-btn">
								<i className="bi bi-envelope-fill me-2"></i>
								Contact us
							</Button>
						</Link>
					</h3>
				</Col>
			</Row>
		</Container>
	);
};

export default About;
